/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

// Swiper is available globally
// Swiper modules are available globally
// gsap is available globally

// Import Swiper styles
// Swiper CSS is included globally
// Swiper CSS is included globally
// Swiper CSS is included globally

(function() {
  // Animation flags to prevent rapid switching
  let isAnimating = false;
  
  /**
   * Animate content in with GSAP
   */
  function animateContentIn(slide) {
    if (!slide) {
      isAnimating = false;
      return gsap.timeline(); // Return empty timeline
    }
    
    const textContent = slide.querySelector('.testimonial-description');
    const imageContent = slide.querySelector('.testimonial-image');
    
    // Make sure we have elements to animate
    if (!textContent && !imageContent) {
      console.warn("No content elements found to animate");
      isAnimating = false;
      return gsap.timeline(); // Return empty timeline
    }
    
    // Kill any existing animations on these elements first
    if (textContent) gsap.killTweensOf(textContent);
    if (imageContent) gsap.killTweensOf(imageContent);
    
    // Set initial states - safely check each element exists
    if (textContent) gsap.set(textContent, { y: 70, opacity: 0, force3D: true });
    if (imageContent) gsap.set(imageContent, { y: 70, opacity: 0, force3D: true });
    
    // Create animation timeline
    const tl = gsap.timeline({
      onComplete: () => {
        // FIXED: Ensure animation flag is properly reset
        isAnimating = false;
      }
    });
    
    // Animate text first (if it exists)
    if (textContent) {
      tl.to(textContent, {
        duration: 0.8, // FIXED: Reduced animation time
        y: 0,
        opacity: 1,
        ease: "power2.out"
      });
    }
    
    // Animate image with slight delay (if it exists)
    if (imageContent) {
      tl.to(imageContent, {
        duration: 0.8, // FIXED: Reduced animation time
        y: 0,
        opacity: 1,
        ease: "power2.out"
      }, textContent ? "-=0.6" : 0); // FIXED: Reduced overlap time
    }
    
    return tl;
  }
  
  /**
   * Animate content out with GSAP
   */
  function animateContentOut(slide) {
    if (!slide) return gsap.timeline(); // Return empty timeline
    
    const textContent = slide.querySelector('.testimonial-description');
    const imageContent = slide.querySelector('.testimonial-image');
    
    // Check if we have elements to animate
    if (!textContent && !imageContent) {
      return gsap.timeline(); // Return empty timeline
    }
    
    // Prepare elements array for animation
    const elements = [];
    if (textContent) elements.push(textContent);
    if (imageContent) elements.push(imageContent);
    
    // Kill any existing animations
    gsap.killTweensOf(elements);
    
    // Create animation timeline
    const tl = gsap.timeline();
    
    // Animate elements out if we have any
    if (elements.length > 0) {
      tl.to(elements, {
        duration: 0.3, // FIXED: Reduced animation time
        y: 30,
        opacity: 0,
        ease: "power2.in",
        stagger: 0.1
      });
    }
    
    return tl;
  }

  function animateContentOutWithCallback(slide, onCompleteCallback) {
    const tl = animateContentOut(slide);
    if (typeof onCompleteCallback === 'function') {
      tl.eventCallback("onComplete", onCompleteCallback);
    }
    return tl;
  }

  function initDesktopSlider(slider) {
    // Initialize the thumbnail swiper first
    const thumbsSwiper = new Swiper(slider.querySelector('.swiper-testimonial-thumbs'), {
      slidesPerView: 'auto',
      spaceBetween: 15,
      direction: 'vertical',
      watchSlidesProgress: true,
      slideToClickedSlide: true
    });

    // Initialize desktop variables
    let desktopMainSwiper; // Variable to store the desktop main swiper

    // Set up all slides to their initial states
    const allSlides = slider.querySelectorAll('.testimonial-main-slide');
    allSlides.forEach(slide => {
      gsap.set(slide, {
        position: 'absolute',
        top: 0,
        left: 0,
        visibility: 'hidden',
        opacity: 0,
        zIndex: 1
      });
    });
    
    // Prepare first slide to be visible
    const firstSlide = slider.querySelector('.testimonial-main-slide');
    if (firstSlide) {
		// Make slide visible but ensure content remains hidden
		gsap.set(firstSlide, {
		  visibility: 'visible',
		  opacity: 1,
		  zIndex: 5
		});
		
		const firstText = firstSlide.querySelector('.testimonial-description');
		const firstImage = firstSlide.querySelector('.testimonial-image');
		
		// Ensure content is fully hidden with no possibility of flashing
		if (firstText) {
			gsap.set(firstText, { 
			y: 70, 
			opacity: 0,
			visibility: 'hidden'
			});
		}
		if (firstImage) {
			gsap.set(firstImage, { 
			y: 70, 
			opacity: 0,
			visibility: 'hidden'
			});
		}
		
		// Use requestAnimationFrame for more reliable timing
		requestAnimationFrame(() => {
		  // Now make content visible but still at opacity 0
		  if (firstText) gsap.set(firstText, { visibility: 'visible' });
		  if (firstImage) gsap.set(firstImage, { visibility: 'visible' });
		  
		  // Then animate in on the next frame
		  requestAnimationFrame(() => {
			animateContentIn(firstSlide);
		  });
		});
	  }

    // Initialize the main testimonial swiper with thumbs
    desktopMainSwiper = new Swiper(slider.querySelector('.swiper-testimonial-main'), {
      slidesPerView: 1,
      spaceBetween: 0,
	  noSwiping: true,
	  noSwipingClass: '.noswipe',
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 400, // FIXED: Reduced speed to make transitions more responsive
      thumbs: {
        swiper: thumbsSwiper
      },
      allowTouchMove: false,
      autoHeight: false,
      
      on: {
        slideChangeTransitionStart: function() {
          // FIXED: Do not immediately return, only block slide change
        //   if (isAnimating) {
        //     console.log('Animation in progress, slide change request queued');
        //     // Allow the swiper to handle the slide change internally, just don't animate
        //     return;
        //   }
          
          // Set flag immediately to prevent multiple clicks
          isAnimating = true;

          const currentSlide = this.slides[this.previousIndex];
          const newSlide = this.slides[this.activeIndex];

          // Animate out the current slide content and then animate in the new one
          if (currentSlide) {
            animateContentOutWithCallback(currentSlide, () => {
              // Hide the old slide completely
              gsap.set(currentSlide, {
                visibility: 'hidden',
                opacity: 0,
                zIndex: 1
              });

              // Make the new slide visible but with hidden content
              if (newSlide) {
                gsap.set(newSlide, {
                  visibility: 'visible',
                  opacity: 1,
                  zIndex: 5
                });

                // Animate in the new content
                animateContentIn(newSlide);
              } else {
                isAnimating = false; // Reset flag if no new slide
              }
            });
          } else {
            // If no current slide (first load), just animate in the new slide
            if (newSlide) {
              gsap.set(newSlide, {
                visibility: 'visible',
                opacity: 1,
                zIndex: 5
              });
              animateContentIn(newSlide);
            } else {
              isAnimating = false; // Reset flag if no new slide
            }
          }

          // Update thumbnail state
          const allThumbs = slider.querySelectorAll('.testimonial-thumb-slide');
          allThumbs.forEach((thumb, index) => {
            thumb.style.opacity = '1';
            if (index === this.activeIndex) {
              thumb.classList.add('swiper-slide-thumb-active');
            } else {
              thumb.classList.remove('swiper-slide-thumb-active');
            }
          });
        },
        
        slideChangeTransitionEnd: function() {
          // FIXED: Added better error handling and recovery
          const newSlide = this.slides[this.activeIndex];
          if (newSlide) {
            // Ensure slide is visible
            gsap.set(newSlide, {
              visibility: 'visible',
              opacity: 1,
              zIndex: 5
            });
            
            // Ensure content is visible (backup in case animation failed)
            const description = newSlide.querySelector('.testimonial-description');
            const image = newSlide.querySelector('.testimonial-image');
            
            if (isAnimating) {
              if (description) gsap.set(description, { opacity: 1, y: 0 });
              if (image) gsap.set(image, { opacity: 1, y: 0 });
              isAnimating = false;
            }
          }
          
          // FIXED: Ensure isAnimating is reset when transition ends
          setTimeout(() => {
            if (isAnimating) {
              isAnimating = false;
            }
          }, 50);
		// if (firstMobileSlide) {
		// 	const firstText = firstMobileSlide.querySelector('.testimonial-description');
		// 	const firstImage = firstMobileSlide.querySelector('.testimonial-image');
			
		// 	// Use requestAnimationFrame for more reliable timing
		// 	requestAnimationFrame(() => {
		// 	  // Now make content visible but still at opacity 0
		// 	  if (firstText) gsap.set(firstText, { visibility: 'visible' });
		// 	  if (firstImage) gsap.set(firstImage, { visibility: 'visible' });
			  
		// 	  // Then animate in on the next frame
		// 	  requestAnimationFrame(() => {
		// 		animateContentIn(firstMobileSlide);
		// 	  });
		// 	});
		// }
          
          // Adjust heights
          adjustLeftSideHeight();
        },
        
        init: function() {
          // Set initial active state for first thumb
          const firstThumb = slider.querySelector('.testimonial-thumb-slide');
          if (firstThumb) {
            firstThumb.classList.add('swiper-slide-thumb-active');
          }
          
          // Animate in first slide content
          if (firstSlide) {
            setTimeout(() => {
              animateContentIn(firstSlide);
            }, 300);
          }

          // Adjust heights
          setTimeout(adjustLeftSideHeight, 200);
        }
      }
    });

    // Add navigation buttons functionality
    const prevButton = slider.querySelector('.flinders-testimonial-prev');
    const nextButton = slider.querySelector('.flinders-testimonial-next');

    if (prevButton && nextButton) {
		prevButton.addEventListener('click', function() {
		  if (desktopMainSwiper) {
			// Check if we're at the first slide
			if (desktopMainSwiper.isBeginning) {
			  // Loop to the last slide
			  desktopMainSwiper.slideTo(desktopMainSwiper.slides.length - 1);
			} else {
			  // Regular previous slide behavior
			  desktopMainSwiper.slidePrev();
			}
		  }
		});
	  
		nextButton.addEventListener('click', function() {
		  if (desktopMainSwiper) {
			// Check if we're at the last slide
			if (desktopMainSwiper.isEnd) {
			  // Loop to the first slide
			  desktopMainSwiper.slideTo(0);
			} else {
			  // Regular next slide behavior
			  desktopMainSwiper.slideNext();
			}
		  }
		});
	  }
    // Set the height of the left side to match the right side
	function adjustLeftSideHeight() {
		const rightSide = slider.querySelector('.flinders-testimonial-right');
		const leftSide = slider.querySelector('.flinders-testimonial-left');
		const navButtons = slider.querySelector('.flinders-testimonial-navigation');
		
		if (rightSide && leftSide) {
		// Fixed height for desktop
		const rightHeight = 362;
		
		// Get the thumb slides
		const thumbsContainer = slider.querySelector('.swiper-testimonial-thumbs');
		const thumbSlides = thumbsContainer ? thumbsContainer.querySelectorAll('.testimonial-thumb-slide') : [];
		
		// Calculate heights
		const navHeight = navButtons ? navButtons.offsetHeight + 15 : 65;
		
		// Set the left column height
		leftSide.style.height = (rightHeight + navHeight) + 'px';
		
		if (thumbsContainer) {
			// Set container height regardless of number of slides
			thumbsContainer.style.height = rightHeight + 'px';
			
			// Special case for single tile
			if (thumbSlides.length === 1) {
			if (thumbSlides[0]) {
				thumbSlides[0].style.height = rightHeight + 'px';
				
				const thumbContent = thumbSlides[0].querySelector('.testimonial-thumb-content');
				if (thumbContent) {
				thumbContent.style.height = rightHeight + 'px';
				thumbContent.style.display = 'flex';
				thumbContent.style.flexDirection = 'column';
				thumbContent.style.justifyContent = 'center';
				}
			}
			} 
			// New special case for exactly two thumbnails
			else if (thumbSlides.length === 2) {
			const thumbHeight = (rightHeight / 2) - 7.5; // Subtract half the gap between thumbs
			
			thumbSlides.forEach(slide => {
				slide.style.height = thumbHeight + 'px';
				
				const thumbContent = slide.querySelector('.testimonial-thumb-content');
				if (thumbContent) {
				thumbContent.style.height = thumbHeight + 'px';
				thumbContent.style.display = 'flex';
				thumbContent.style.flexDirection = 'column';
				thumbContent.style.justifyContent = 'center';
				}
			});
			}
			
			// Ensure all thumbnails have proper opacity
			thumbSlides.forEach(slide => {
			slide.style.opacity = '1';
			});
		}
		}
	}

    // Add click handler for thumbnails
    const thumbSlides = slider.querySelectorAll('.testimonial-thumb-slide');
    thumbSlides.forEach((slide, index) => {
      // FIXED: Improved click handler for thumbnails
      slide.addEventListener('click', function() {
        if (desktopMainSwiper && typeof desktopMainSwiper.slideTo === "function") {
          // Allow slide change even if animating
          desktopMainSwiper.slideTo(index);
        }
      });
    });

    // Set up resize handler
    if (typeof ResizeObserver !== 'undefined') {
      const rightSide = slider.querySelector('.flinders-testimonial-right');
      
      if (rightSide) {
        let resizeTimeout;
        const resizeObserver = new ResizeObserver(() => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(adjustLeftSideHeight, 100);
        });
        
        resizeObserver.observe(rightSide);
        slider._desktopResizeObserver = resizeObserver;
      }
    } else {
      // Fallback to window resize
      let resizeTimer;
      const handleResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(adjustLeftSideHeight, 100);
      };
      
      window.addEventListener('resize', handleResize);
      slider._desktopResizeHandler = handleResize;
    }
    
    // Initial height adjustment
    setTimeout(adjustLeftSideHeight, 100);
    
    // Return the swiper instance for external reference
    return desktopMainSwiper;
  }

  function initMobileSlider(slider) {
    // Static width setting for mobile thumbnails
    const slideWidth = 274;
    
    // Initialize mobile thumbnail swiper
    const mobileThumbsSwiper = new Swiper(slider.querySelector('.swiper-testimonial-mobile-thumbs'), {
      slidesPerView: 'auto',
      spaceBetween: 10,
	  freeMode: true,
      watchSlidesProgress: true,
	  allowTouchMove: true,
      slideToClickedSlide: true,
      touchRatio: 1,
      resistance: true,
      resistanceRatio: 0.85,
      speed: 300
    });
    
    // Set up all mobile slides to their initial states using GSAP
    const mobileSlides = slider.querySelectorAll('.swiper-testimonial-mobile-main .swiper-slide');
    mobileSlides.forEach(slide => {
      gsap.set(slide, {
        position: 'absolute',
        top: 0,
        left: 0,
        visibility: 'hidden',
        opacity: 0,
        zIndex: 1
      });
    });
    
    // Prepare first mobile slide
    const firstMobileSlide = slider.querySelector('.swiper-testimonial-mobile-main .swiper-slide');
    if (firstMobileSlide) {
		// Make slide visible but ensure content remains hidden
		gsap.set(firstMobileSlide, {
		  visibility: 'visible',
		  opacity: 1,
		  zIndex: 5
		});
		
		const firstText = firstMobileSlide.querySelector('.testimonial-description');
		const firstImage = firstMobileSlide.querySelector('.testimonial-image');
		
		// Ensure content is fully hidden with no possibility of flashing
		if (firstText) {
			gsap.set(firstText, { 
				y: 70, 
				opacity: 0,
				visibility: 'hidden'
			});
		}
		if (firstImage) {
			gsap.set(firstImage, { 
				y: 70, 
				opacity: 0,
				visibility: 'hidden'
			});
		}
	  }
    
    // Initialize the mobile main swiper
    const mobileMainSwiper = new Swiper(slider.querySelector('.swiper-testimonial-mobile-main'), {
      slidesPerView: 1,
      spaceBetween: 0,
	  noSwiping: true,
	  noSwipingClass: '.noswipe',
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 400, // FIXED: Reduced animation duration for better responsiveness
      thumbs: {
        swiper: mobileThumbsSwiper
      },
      
      on: {
        slideChangeTransitionStart: function() {
        //   if (isAnimating) {
        //     console.log('Mobile: Animation in progress, slide change request queued');
        //     return;
        //   }
          
          // Set flag immediately
          isAnimating = true;

          const currentSlide = this.slides[this.previousIndex];
          const newSlide = this.slides[this.activeIndex];

          // Update mobile thumbnails immediately
          mobileThumbsSwiper.slideTo(this.activeIndex);

          if (currentSlide) {
            animateContentOutWithCallback(currentSlide, () => {
              gsap.set(currentSlide, {
                visibility: 'hidden',
                opacity: 0,
                zIndex: 1
              });
              
              if (newSlide) {
                gsap.set(newSlide, {
                  visibility: 'visible',
                  opacity: 1,
                  zIndex: 5
                });
                
                animateContentIn(newSlide);
              } else {
                isAnimating = false;
              }
            });
          } else {
            if (newSlide) {
              gsap.set(newSlide, {
                visibility: 'visible',
                opacity: 1,
                zIndex: 5
              });
              animateContentIn(newSlide);
            } else {
              isAnimating = false;
            }
          }

          // Update thumbnail classes
          const allThumbs = slider.querySelectorAll('.testimonial-mobile-thumb');
          allThumbs.forEach((thumb, index) => {
            thumb.style.opacity = '1';
            if (index === this.activeIndex) {
              thumb.classList.add('swiper-slide-thumb-active');
            } else {
              thumb.classList.remove('swiper-slide-thumb-active');
            }
          });
        },
        
        slideChangeTransitionEnd: function() {
          // FIXED: Better error handling and recovery
          const newSlide = this.slides[this.activeIndex];
          if (newSlide) {
            // Ensure slide is visible
            gsap.set(newSlide, {
              visibility: 'visible',
              opacity: 1,
              zIndex: 5
            });
            
            // FIXED: More aggressive recovery from stuck animations
            if (isAnimating) {
              const description = newSlide.querySelector('.testimonial-description');
              const image = newSlide.querySelector('.testimonial-image');
              
              if (description) gsap.set(description, { opacity: 1, y: 0 });
              if (image) gsap.set(image, { opacity: 1, y: 0 });
              isAnimating = false;
            }
          }
          
          // FIXED: Additional safety timeout to reset animation flag
          setTimeout(() => {
            if (isAnimating) {
              isAnimating = false;
            }
          }, 100);
        },
        
        init: function() {
          if (this.slides.length > 0) {
            // Set initial active state for first thumbnail
            const firstThumb = slider.querySelector('.testimonial-mobile-thumb');
            if (firstThumb) {
              firstThumb.classList.add('swiper-slide-thumb-active');
            }
            
            // Animate in the first slide content
            // if (firstMobileSlide) {
            //   setTimeout(() => {
            //     animateContentIn(firstMobileSlide);
            //   }, 300);
            // }
			if (firstMobileSlide) {
				const firstText = firstMobileSlide.querySelector('.testimonial-description');
				const firstImage = firstMobileSlide.querySelector('.testimonial-image');
				
				// Use requestAnimationFrame for more reliable timing
				requestAnimationFrame(() => {
				  // Now make content visible but still at opacity 0
				  if (firstText) gsap.set(firstText, { visibility: 'visible' });
				  if (firstImage) gsap.set(firstImage, { visibility: 'visible' });
				  
				  // Then animate in on the next frame
				  requestAnimationFrame(() => {
					animateContentIn(firstMobileSlide);
				  });
				});
			}
            
            // Set fixed width for thumbnails
            const thumbs = slider.querySelectorAll('.testimonial-mobile-thumb');
            thumbs.forEach(thumb => {
              thumb.style.width = slideWidth + 'px';
            });
            
            // Initial height equalization
            requestAnimationFrame(equalizeThumbHeights);
          }
        }
      }
    });

    // Handle click on thumbnails
    const thumbSlides = slider.querySelectorAll('.testimonial-mobile-thumb');
    thumbSlides.forEach((slide, index) => {
      // FIXED: Improved click handler for mobile thumbnails
      slide.addEventListener('click', function() {
        if (mobileMainSwiper) {
          // Allow slide change even if animating
          mobileMainSwiper.slideTo(index);
        }
      });
    });
    
    // Function to equalize the height of all thumbnail items
    function equalizeThumbHeights() {
      const thumbs = slider.querySelectorAll('.testimonial-mobile-thumb');
      if (thumbs.length <= 1) return;
      
      // Reset heights first
      thumbs.forEach(thumb => {
        thumb.style.height = 'auto';
      });
      
      // Find the tallest thumb
      let maxHeight = 0;
      thumbs.forEach(thumb => {
        const height = thumb.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      
      // Set all thumbs to the tallest height
      if (maxHeight > 0) {
        thumbs.forEach(thumb => {
          thumb.style.height = maxHeight + 'px';
        });
      }
    }
    
    // Set up responsive handling
    if (typeof ResizeObserver !== 'undefined') {
      const containers = [
        slider.querySelector('.swiper-testimonial-mobile-thumbs'),
        slider.querySelector('.swiper-testimonial-mobile-main'),
        slider.querySelector('.flinders-testimonial-mobile')
      ].filter(Boolean);
      
      if (containers.length > 0) {
        let resizeTimeout;
        
        const resizeObserver = new ResizeObserver(() => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            if (mobileThumbsSwiper && mobileThumbsSwiper.update) mobileThumbsSwiper.update();
            if (mobileMainSwiper && mobileMainSwiper.update) mobileMainSwiper.update();
            equalizeThumbHeights();
          }, 200);
        });
        
        containers.forEach(container => resizeObserver.observe(container));
        slider._mobileResizeObserver = resizeObserver;
      }
    } else {
      // Fallback to window resize event
      let resizeTimer;
      const handleResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          equalizeThumbHeights();
          if (mobileThumbsSwiper && mobileThumbsSwiper.update) mobileThumbsSwiper.update();
          if (mobileMainSwiper && mobileMainSwiper.update) mobileMainSwiper.update();
        }, 200);
      };
      
      window.addEventListener('resize', handleResize);
      slider._mobileResizeHandler = handleResize;
    }
    
    // Add overflow handling for thumbnails
    const thumbsContainer = slider.querySelector('.swiper-testimonial-mobile-thumbs');
    if (thumbsContainer) {
      thumbsContainer.classList.add('swiper-overflow-visible');
      const wrapperElement = thumbsContainer.querySelector('.swiper-wrapper');
      if (wrapperElement) {
        wrapperElement.style.overflow = 'visible';
      }
    }
    
    // Return the swiper instances for external reference
    return {
      thumbs: mobileThumbsSwiper,
      main: mobileMainSwiper
    };
  }
  
  // Main initialization function
  function initTestimonialSliders() {
    const sliders = document.querySelectorAll('.flinders-testimonial-slider');
    
    if (sliders.length === 0) return;
    
    sliders.forEach(function(slider) {
      const testimonialCount = parseInt(slider.getAttribute('data-testimonials-count') || 0);
      
      if (testimonialCount > 0) {
        // Reset animation flag
        isAnimating = false;
        
        // Prepare containers
        const mainContainer = slider.querySelector('.swiper-testimonial-main');
        if (mainContainer) {
          mainContainer.style.position = 'relative';
          mainContainer.style.overflow = 'hidden';
        }
        
        const mobileContainer = slider.querySelector('.swiper-testimonial-mobile-main');
        if (mobileContainer) {
          mobileContainer.style.position = 'relative';
          mobileContainer.style.overflow = 'hidden';
        }
        
        // Initialize sliders
        const desktopSwiper = initDesktopSlider(slider);
        const mobileSwiper = initMobileSlider(slider);
        
        // Store swiper instances on the slider element for potential external access
        slider._desktopSwiper = desktopSwiper;
        slider._mobileSwiper = mobileSwiper;
        
        // Add a special class for CSS targeting
        slider.classList.add('slider-initialized');
      }
    });
  }

  // FIXED: Add global error handler to force reset animation flag if errors occur
  window.addEventListener('error', function() {
    isAnimating = false;
  });

  // Execute when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialSliders);
  } else {
    requestAnimationFrame(initTestimonialSliders);
  }
})();